var map = {
	"./aboutEn.webp": 577,
	"./aboutFr.webp": 7146,
	"./accountingFinance.webp": 8910,
	"./announcementsHeaderDetailEn.webp": 2124,
	"./announcementsHeaderDetailFr.webp": 295,
	"./assetManagement.webp": 6944,
	"./assetManagementDetail.webp": 4213,
	"./boxesWithModules.webp": 5139,
	"./boxesWithModulesEn.webp": 8012,
	"./boxesWithModulesFr.webp": 3431,
	"./c3v60_logo.jpg": 9847,
	"./c3v60_logo_thin.png": 4345,
	"./c3vision_logo.jpg": 8287,
	"./c3vision_logo_no_bg.png": 7063,
	"./contactUs1Detail.webp": 735,
	"./contactUsEn.webp": 6804,
	"./contactUsFr.webp": 9279,
	"./crmDetail.webp": 7946,
	"./crm_call_center.jpg": 7926,
	"./cw_main.jpg": 7377,
	"./emailConfirmationEn.webp": 2861,
	"./emailConfirmationFr.webp": 9374,
	"./flexiblePlatform.png": 9639,
	"./flexiblePlatformFront.webp": 9440,
	"./flexiblePlatformSide.webp": 9146,
	"./integrationOtherSystems.webp": 5705,
	"./inventoryManagementDetail.webp": 8993,
	"./madeInCanadaRedBlackEn.webp": 4456,
	"./madeInCanadaRedBlackFr.webp": 5787,
	"./ms_invoice.jpg": 3591,
	"./palestine-flag.svg": 935,
	"./privacyPolicyEn.webp": 386,
	"./privacyPolicyFr.webp": 3849,
	"./procurementDetail.webp": 2244,
	"./productionOne.webp": 4366,
	"./productionOneDetail.webp": 5627,
	"./productionTwo.webp": 8928,
	"./productionTwoDetail.webp": 5989,
	"./registerPageDetail.webp": 4902,
	"./registerPageEn.webp": 7932,
	"./registerPageFr.webp": 4295,
	"./salaryPayroll.webp": 6004,
	"./salesDetail.png": 904,
	"./salesDetail.webp": 8834,
	"./securityLock.webp": 7148,
	"./smb_image1.jpg": 6354,
	"./termsOfServiceEn.webp": 9919,
	"./termsOfServiceFr.webp": 8284,
	"./thankYouEn.webp": 253,
	"./thankYouFr.webp": 4638,
	"./timeManagement.webp": 1687,
	"./tm_then_now.jpg": 4343,
	"./tm_then_now_portion.jpg": 7767,
	"./tm_then_now_portion1.jpg": 4250,
	"./warehouseManagement.webp": 4879,
	"./warehouseManagementDetail.webp": 2914,
	"./wh_robots.jpg": 516,
	"./yl_hs_portion.jpg": 5870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;